// Showdown presentations, in order: MAIN pot, then each side pot. In a bomb pot every pot is shown twice — TOP board first,
// then BOTTOM — even when one player scoops, so each board's own two hole cards lift on their own and nobody sees three or
// four cards come down at once. Mirrors HoldemTable.presentations on the server (which sizes the hand-end pause).
export const presentationsOf = (awards) => {
  const groups = [];
  for (const k of [...new Set(awards.map((a) => a.pot ?? 0))].sort((a, b) => a - b)) {
    const aw = awards.filter((a) => (a.pot ?? 0) === k)
      .sort((x, y) => (x.board === "TOP" ? -1 : y.board === "TOP" ? 1 : 0));
    if (aw.length === 2) groups.push([aw[0]], [aw[1]]); else groups.push(aw);
  }
  return groups;
};

// What a presentation lifts out of the seats: which winners, and which board (null = both / the only one). Two consecutive
// presentations with the same lift key keep the cards in place — one winner scooping Main, SP1 and SP2 lifts once.
export const liftKeyOf = (group) => (group ? JSON.stringify([[...new Set(group.flatMap((a) => a.winners))].sort(), group.length === 1 ? group[0].board || null : null]) : null);

// How a made hand reads on paper: strongest group first, then by rank — "10 9 8 7 6" for a straight, the trips before the
// pair in a full house, the higher pair first in two pair. A-5-4-3-2 (the wheel) shows its ace last.
const RANKS = "23456789TJQKA";
export const orderHand = (cards) => {
  const rank = (c) => RANKS.indexOf(c[0] === "1" ? "T" : c[0]); // "Th" and the odd "10h" both read as a ten
  const counts = {};
  for (const c of cards) counts[rank(c)] = (counts[rank(c)] || 0) + 1;
  const ranks = new Set(cards.map(rank));
  const wheel = cards.length === 5 && ranks.size === 5 && [12, 3, 2, 1, 0].every((r) => ranks.has(r)); // A 5 4 3 2
  const key = (c) => (wheel && rank(c) === 12 ? -1 : rank(c));
  return [...cards].sort((a, b) => counts[rank(b)] - counts[rank(a)] || key(b) - key(a));
};
